import axios from "axios";
import { authCheckState } from "../store/actions/index";

function getLocalAccessToken() {
  const token = window.localStorage.getItem("token");
  return token;
}

const baseURL = "http://157.175.80.11/api/v1/";

const instance = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    // console.log(config);
    const token = getLocalAccessToken();
    if (token) {
      config.headers["x-auth-token"] = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    // console.log(originalConfig);
    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        authCheckState();
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
      if (err.response.status === 400 && err.response.data) {
        // console.log(err.response.data.errors[0].message);
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);
export default instance;
